module.exports = __webpack_public_path__ + "img/button_start.80158997.png";